import {TableOrFormRenderOptionsType} from 'notebook/structured-tables/StructuredTableOrFormOutsideNotebook';
import {BenchlingState} from 'redux-stores/reduceApp';
import {getStore} from 'redux-stores/Store';

/**
 * Redux actions (and associated constants) for toggling between form view and table view.
 */

export enum FormTableSwitcherStatusActionType {
  SET_FORM_TABLE_SWITCHER_STATUS_ACTION = 'SET_FORM_TABLE_SWITCHER_STATUS_ACTION',
}

interface SetFormTableSwitcherStatusAction {
  type: FormTableSwitcherStatusActionType.SET_FORM_TABLE_SWITCHER_STATUS_ACTION;
  tableCid: string;
  switcherStatus: TableOrFormRenderOptionsType;
}

// Exported for testing only
export function _createSetFormTableSwitcherStatusAction(
  tableCid: string,
  switcherStatus: TableOrFormRenderOptionsType
): SetFormTableSwitcherStatusAction {
  return {
    type: FormTableSwitcherStatusActionType.SET_FORM_TABLE_SWITCHER_STATUS_ACTION,
    tableCid,
    switcherStatus,
  };
}

export function setFormTableSwitcherStatus(tableCid: string, editStatus: TableOrFormRenderOptionsType): void {
  getStore().dispatch(_createSetFormTableSwitcherStatusAction(tableCid, editStatus));
}

export function getFormTableSwitcherStatus(
  state: BenchlingState,
  tableCid: string
): TableOrFormRenderOptionsType | null {
  return state.ui.formTableSwitcherState[tableCid] ?? null;
}

export type FormTableSwitcherStateAction = SetFormTableSwitcherStatusAction;
